import { render, staticRenderFns } from "./CookieSettingsDialog.vue?vue&type=template&id=4225d845&scoped=true&"
import script from "./CookieSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./CookieSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CookieSettingsDialog.vue?vue&type=style&index=0&id=4225d845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225d845",
  null
  
)

export default component.exports